<script setup>
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'

import { useWebSiteStore } from '@/stores/web-site.store'
import { useFocusRestore } from '@/composables/focus-restore'

import GridDropDownBox from '@/components/shared/GridDropDownBox.vue'

const webSiteStore = useWebSiteStore()

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  isPortal: {
    type: Boolean,
    default: false,
  },
  showClearButton: {
    type: Boolean,
    default: false,
  },
  value: {
    type: Number,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  validationGroup: {
    type: String,
    default: undefined,
  },
  validationRules: {
    type: Array,
    default: () => [],
  },
})

const defaultDataSource = new DataSource({
  store: new ArrayStore({
    data: props.isPortal ? webSiteStore.countries.filter(i => i.id > 0) : webSiteStore.countries,
    key: 'id',
  }),
  searchExpr: ['code', 'name'],
})

const emit = defineEmits({
  valueChanged: (e) => true,
})

const { rootRef } = useFocusRestore('country')
</script>

<template>
  <div ref="rootRef">
    <grid-drop-down-box
      :value="props.value || props.data?.value"
      :data-source="defaultDataSource"
      :remote-operations="false"
      :show-clear-button="props.showClearButton"
      :disabled="props.disabled"
      :validation-group="props.validationGroup"
      :validation-rules="props.validationRules"
      :columns="[
        { dataField: 'code', caption: $t('common.code') },
        { dataField: 'name', caption: $t('common.name'), sortOrder: 'asc' },
        { dataField: 'iso3_code', caption: `ISO ${$t('common.code')}` }
      ]"
      @value-changed="(e) => {
        props.data?.setValue(e)
        emit('valueChanged', { value: e })
      }"
    />
  </div>
</template>
